import { Injectable } from '@angular/core';

import {
  PageLangService,
  AboutDialogService,
  SystemErrorService,
  SystemStatusChangeService,
  ActivityIndicatorService,
  RestErrorHandlerService,
  RestApplicationErrorHandlerService,
  PageTitleService,
  MenuService,
  AnalyticsService,
  WebbrokerResponsiveService,
  OneTrustService,
  DataAnalyticsTaggingService,
  InitGlobalNotificationBannerService,
  ChatService,
  MaterialService
} from '@tdwb/core';
import { TargetedAdService } from './modules/core/targeted-ad/targeted-ad.service';

import { WebbrokerInitPageService } from './webbroker-init-page.service';
import { WebbrokerInitNavigationService } from './webbroker-init-navigation.service';

/**
 * Initializes application after modules have been loaded before ui router starts listening
 */
@Injectable(
  { providedIn: 'root' }
)
export class WebbrokerInitService {

  constructor(private aboutDialogService: AboutDialogService,
              private pageLangService: PageLangService,
              private initNavigationService: WebbrokerInitNavigationService,
              private targetedAdService: TargetedAdService,
              private initPageService: WebbrokerInitPageService,
              private systemErrorService: SystemErrorService,
              private analyticsService: AnalyticsService,
              private activityIndicatorService: ActivityIndicatorService,
              private systemStatusChangeService: SystemStatusChangeService,
              private menuService: MenuService,
              private restAppErrorHandlerService: RestApplicationErrorHandlerService,
              private restErrorHandlerService: RestErrorHandlerService,
              private pageTitleService: PageTitleService,
              private webbrokerResponsiveService: WebbrokerResponsiveService,
              private oneTrustService: OneTrustService,
              private dataAnalyticsTaggingService: DataAnalyticsTaggingService,
              private initGlobalNotificationBannerService: InitGlobalNotificationBannerService,
              private chatService: ChatService,
              private materialService: MaterialService) {
  }

  init(bootstrapSuccess: boolean = true): void {
    if (bootstrapSuccess) {
      this.webbrokerResponsiveService.init();
      this.pageTitleService.init();
      this.analyticsService.init();
      this.oneTrustService.init();
      this.dataAnalyticsTaggingService.init('tdw:wbt');
      this.targetedAdService.init();
      this.initNavigationService.init();
      this.systemStatusChangeService.init();
      this.systemErrorService.init();
      this.activityIndicatorService.init();
      this.restErrorHandlerService.addHandler(this.restAppErrorHandlerService);
      this.initGlobalNotificationBannerService.init();
      this.chatService.init();
    } else {
      this.menuService.hide();
    }
    this.aboutDialogService.init();
    this.materialService.init();
    this.pageLangService.init();
    this.initPageService.init();
  }
}
